module.exports = __webpack_public_path__ + "media/img/favicon-32x32-ec15b38779cd9c1a8c12d00b20a65ce0.png";